import { type InputHTMLAttributes, forwardRef, useState } from "react";
import { IoEyeOutline, IoEyeOffOutline } from "react-icons/io5";

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  error?: string;
  showPasswordToggle?: boolean;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  (
    { className = "", type, error, showPasswordToggle = false, ...props },
    ref,
  ) => {
    const [showPassword, setShowPassword] = useState(false);

    const inputType = showPasswordToggle
      ? showPassword
        ? "text"
        : "password"
      : type;

    // Se className contém pl- ou pr-, não aplicar padding padrão
    const hasCustomPadding =
      className.includes("pl-") || className.includes("pr-");
    const defaultPadding = hasCustomPadding
      ? ""
      : showPasswordToggle
        ? "pr-12 pl-4"
        : "px-4";

    return (
      <div className="space-y-2">
        <div className="relative h-12">
          <input
            type={inputType}
            className={`flex h-12 w-full rounded-xl border ${
              error ? "border-red-500" : "border-gray-200"
            } bg-white py-3 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-gray-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#24a878] focus-visible:border-transparent disabled:cursor-not-allowed disabled:opacity-50 ${defaultPadding} ${className}`}
            ref={ref}
            {...props}
          />
          {showPasswordToggle && (
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className="absolute right-3 top-6 -translate-y-1/2 text-gray-400 hover:text-gray-700 transition-colors z-10"
            >
              {showPassword ? (
                <IoEyeOffOutline className="text-xl" />
              ) : (
                <IoEyeOutline className="text-xl" />
              )}
            </button>
          )}
        </div>
        {error && <p className="text-sm text-red-500">{error}</p>}
      </div>
    );
  },
);

Input.displayName = "Input";
